import { render, staticRenderFns } from "./SocialMediaIconRowComponent.vue?vue&type=template&id=4a3153c2&scoped=true&"
import script from "./SocialMediaIconRowComponent.vue?vue&type=script&lang=js&"
export * from "./SocialMediaIconRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaIconRowComponent.vue?vue&type=style&index=0&id=4a3153c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3153c2",
  null
  
)

export default component.exports